(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHero(root) {
    if (!root || root.dataset.rpHomeReady === 'true') return;
    root.dataset.rpHomeReady = 'true';
    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

    root.classList.add('is-enhanced');
    const counts = [...root.querySelectorAll('[data-rp-home-count]')].map(node => ({
      node,
      target: Number(node.dataset.rpHomeCount) || 0
    }));
    let counted = false;
    let visible = false;
    let framePending = false;
    let lastParallax = '';

    function updateParallax() {
      framePending = false;
      if (!visible) return;
      const rect = root.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const offset = Math.max(-16, Math.min(16, (progress - .5) * 32));
      const value = `${offset.toFixed(1)}px`;
      if (lastParallax !== value) {
        root.style.setProperty('--rp-home-parallax', value);
        lastParallax = value;
      }
    }

    function onScroll() {
      if (!visible || framePending) return;
      framePending = true;
      requestAnimationFrame(updateParallax);
    }

    function animateCounts() {
      if (counted) return;
      counted = true;
      const start = performance.now();
      const duration = 1350;
      function tick(now) {
        const progress = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        counts.forEach(item => {
          const value = String(Math.round(item.target * eased));
          if (item.node.textContent !== value) item.node.textContent = value;
        });
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        visible = entry.isIntersecting;
        if (visible) {
          root.classList.add('is-visible');
          animateCounts();
          onScroll();
        }
      });
    }, { threshold: .15 });
    observer.observe(root);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-rp-home-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();


